import React, { useCallback, useContext, useEffect } from 'react';
import { LinearProgress, Text } from '@rneui/themed';
import { useFinalizePurchaseMutation, } from '@annunciate/query';
import { useAuthStateStore, messageFactory, Topic, AnalyticsEventEmitter, } from '@annunciate/core';
import { useLoginRedirect, useOnNavigate } from '../hooks';
import { Oidc } from '../context';
const getUUID = useAuthStateStore.getState().getUUID;
export const PurchaseFinalize = () => {
    const ctx = useContext(Oidc);
    const onNavigate = useOnNavigate();
    const [authToken, hasAuthInitialized] = useAuthStateStore((state) => [
        state.token,
        state.hasAuthInitialized,
    ]);
    const { mutateAsync } = useFinalizePurchaseMutation();
    const onLoginRedirect = useLoginRedirect();
    const handleEmitEvent = useCallback(async (uuid) => {
        const detail = {};
        const params = new URLSearchParams(window.location.search);
        for (let [key, value] of params.entries()) {
            detail[key] = value;
        }
        if (uuid) {
            await AnalyticsEventEmitter.emit(Topic._IDENTIFY, uuid);
        }
        await messageFactory(Topic.PURCHASE_COMPLETED, { detail });
    }, []);
    const onAttemptFinalize = useCallback(async () => {
        let didFinalize = false;
        let isValid = true;
        let extraData = {};
        const params = new URLSearchParams(window.location.search);
        if (params.get('stripe_checkout_session_id')) {
            const result = await mutateAsync({
                channel: 'STRIPE',
                data: {
                    checkoutSessionIdStripe: params.get('stripe_checkout_session_id'),
                },
            });
            didFinalize = true;
            isValid = result.isValid;
            extraData = result.extraData;
        }
        return {
            didFinalize,
            isValid,
            extraData,
        };
    }, [mutateAsync]);
    useEffect(() => {
        let timer;
        async function run() {
            const { didFinalize, isValid, extraData = {}, } = await onAttemptFinalize();
            const redirect = window.localStorage.getItem('purchase/finalize');
            window.localStorage.removeItem('purchase/finalize');
            const currentUUID = getUUID();
            const doUUIDsMatch = !didFinalize || !extraData.userId || (extraData.userId &&
                currentUUID &&
                extraData.userId === currentUUID);
            if (authToken && !didFinalize) {
                timer = setTimeout(() => onNavigate(redirect || '/'), 5000);
                await handleEmitEvent();
            }
            else if (authToken && doUUIDsMatch) {
                await handleEmitEvent();
                await new Promise((resolve) => setTimeout(resolve, 500));
                onNavigate(redirect || '/');
            }
            else if (authToken && !doUUIDsMatch) {
                ctx.signOut(window.location.href);
            }
            else if (isValid) {
                await handleEmitEvent(extraData.userId);
                await new Promise((resolve) => setTimeout(resolve, 500));
                const redirectUri = new URL(window.location.origin);
                redirectUri.pathname = redirect || '';
                await onLoginRedirect({
                    postLoginUri: redirectUri.toString(),
                    loginHint: extraData?.email,
                });
            }
        }
        if (hasAuthInitialized) {
            run();
        }
        return () => {
            if (timer)
                clearTimeout(timer);
        };
    }, [authToken, hasAuthInitialized]);
    return (React.createElement("div", { style: { textAlign: 'center', maxWidth: 700, margin: 'auto', marginTop: 70 } },
        React.createElement(Text, null, "Finalizing your purchase."),
        React.createElement(LinearProgress, { style: { marginVertical: 10 } })));
};
//# sourceMappingURL=PurchaseFinalize.js.map